import { YesNo } from '../../../../../types/api';
import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';
import * as Yup from 'yup';

const {
  formField: { mailingAddress, mailingAddressSameAsBusinessPicklist },
} = loanFormModel;

export class MailingAddressValidation implements ValidationSchema {
  public name: string = mailingAddress.name;
  public label: string = mailingAddress.label;
  public dependsOn: string[] = [mailingAddressSameAsBusinessPicklist.name];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  public when(
    mailingAddressSameAsBusinessPicklist: YesNo,
    schema: Yup.StringSchema
  ) {
    return mailingAddressSameAsBusinessPicklist === 'Yes'
      ? schema
      : schema.required('Street Address is a required field');
  }
}
export default new Validation(new MailingAddressValidation());
